import classNames from 'classnames';
import Image from 'next/image';
import React from 'react';
import { Trans } from 'react-i18next';

import BookIcon from '~/shared/components/icons/book-icon';
import GlobeIcon from '~/shared/components/icons/globe-icon';
import IndividualApproachIcon from '~/shared/components/icons/individual-approach-icon';
import LeadIcon from '~/shared/components/icons/lead-icon';

import './our-goal.scss';

import ourGoalBgIcon from '~/assets/backgrounds/our-goal-bg.webp';

const OurGoal = ({ t }) => {
  return (
    <section id="our-goal" className={classNames('container', 'our-goal')}>
      <h3 className="our-goal__title">{t('text.our-goal')}</h3>
      <div className="our-goal__description">
        <Trans ns="text" components={{ br: <br key={Math.random()} /> }} i18nKey="text.our-goal-text" />
      </div>
      <div className="our-goal__subtitle">{t('text.values-of-prana-club')}</div>
      <div className="our-goal__rows">
        <div className="our-goal__columns">
          <div className="our-goal__column">
            <div className="our-goal__column-icon">
              <BookIcon width={42} height={43} />
            </div>
            <div className="our-goal__column-content">
              <div className="our-goal__column-title">{t('text.help-for-parents')}</div>
              <div className="our-goal__column-text">{t('text.help-for-parents-description')}</div>
            </div>
          </div>
          <div className="our-goal__column">
            <div className="our-goal__column-icon">
              <IndividualApproachIcon width={43} height={42} />
            </div>
            <div className="our-goal__column-content">
              <div className="our-goal__column-title">{t('text.individual-approach')}</div>
              <div className="our-goal__column-text">{t('text.individual-approach-description')}</div>
            </div>
          </div>
        </div>
        <div className="our-goal__columns">
          <div className="our-goal__column">
            <div className="our-goal__column-icon">
              <LeadIcon width={40} height={45} />
            </div>
            <div className="our-goal__column-content">
              <div className="our-goal__column-title">{t('text.accessibility-of-education-for-all')}</div>
              <div className="our-goal__column-text">{t('text.accessibility-of-education-for-all-description')}</div>
            </div>
          </div>
          <div className="our-goal__column">
            <div className="our-goal__column-icon">
              <GlobeIcon width={40} height={45} />
            </div>
            <div className="our-goal__column-content">
              <div className="our-goal__column-title">{t('text.promoting-the-cultural-development-of-ukrainians')}</div>
              <div className="our-goal__column-text">
                {t('text.promoting-the-cultural-development-of-ukrainians-description')}
              </div>
            </div>
          </div>
        </div>
        <Image
          loading="eager"
          alt={t('text.our-goal')}
          title={t('text.our-goal')}
          src={ourGoalBgIcon.src}
          width={492}
          height={475}
          className="our-goal__bg-image"
        />
      </div>
    </section>
  );
};

export default OurGoal;
